
export const sortByName = (list) => {
    return list.sort((itemA, itemB) => {
        let nameA = itemA.name.toLowerCase();
        let nameB = itemB.name.toLowerCase();
        if (nameA < nameB) {
            return -1;
        }
        else if (nameA > nameB) {
            return 1;
        }
        else {
            return 0;
        }
    })
}

export const selectTasksNameDropdownData = tasks => sortByName(
        tasks.map(({ Name, Id }) => {
            return {
                id: Id,
                name: Name
            }
        })
    )

export const selectTasksProjectNameDropdownData = projects => sortByName(
        projects.map(({ Name, Id }) => {
            return {
                id:Id,
                name:Name
            }
        })
    )

export const selectTasksMemberNameDropdownData = tasks => {
        if (tasks.length <= 0) {
            return [];
        }

        let formattedMemberData = [];
        let duplicateTasksMemberDict = {};

        tasks.forEach(({ Members }) => {
            Members.forEach((member) => {

                if (!(member.UserId in duplicateTasksMemberDict)) {
                    duplicateTasksMemberDict[member.UserId] = true;

                    formattedMemberData.push({
                        name: member.User.Name,
                        id: member.UserId,
                    })
                }

            })

        })

        formattedMemberData = sortByName(formattedMemberData);

        return [...formattedMemberData];
    }